import { Component } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Subject } from "rxjs";

@Component({
  selector: "uni-purchase-manager",
  standalone: false,
  templateUrl: "./purchase-manager.component.html",
})
export class PurchaseManagerComponent {
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">Purchasing</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Purchase Orders",
          icon: "pi pi-fw pi-shopping-cart",
          routerLink: ["/purchasing/manage/purchase-orders"],
        },
        {
          label: "Backorder Management",
          icon: "pi pi-fw pi-clock",
          routerLink: ["/purchasing/manage/backorders"],
        },
        {
          label: "EOQ Requirements",
          icon: "pi pi-fw pi-calculator",
          routerLink: ["/purchasing/manage/purchase-eoq"],
        },
      ],
    },
  ];

  // Context-sensitive button for creating new stock P/O (Purchase Orders page)
  createNewPoClicked$ = new Subject<void>();
  showCreateNewPoButton = false;

  createNewPo() {
    this.createNewPoClicked$.next();
  }

  // Context-sensitive buttons for Backorders page
  showBackorderButtons = false;
  backorderButtonsDisabled = true;
  backorderFormDirty = false;

  sendAccountEmailClicked$ = new Subject<void>();
  sendManufEmailClicked$ = new Subject<void>();
  showHideIdColumnsClicked$ = new Subject<void>();
  resetAccountGuidClicked$ = new Subject<void>();
  resetManufGuidClicked$ = new Subject<void>();
  gotoAccountPageClicked$ = new Subject<void>();
  gotoManufPageClicked$ = new Subject<void>();
  saveChangesClicked$ = new Subject<void>();
  cancelChangesClicked$ = new Subject<void>();

  sendAccountEmail() {
    this.sendAccountEmailClicked$.next();
  }

  sendManufEmail() {
    this.sendManufEmailClicked$.next();
  }

  showHideIdColumns() {
    this.showHideIdColumnsClicked$.next();
  }

  resetAccountGuid() {
    this.resetAccountGuidClicked$.next();
  }

  resetManufGuid() {
    this.resetManufGuidClicked$.next();
  }

  gotoAccountPage() {
    this.gotoAccountPageClicked$.next();
  }

  gotoManufPage() {
    this.gotoManufPageClicked$.next();
  }

  saveChanges() {
    this.saveChangesClicked$.next();
  }

  cancelChanges() {
    this.cancelChangesClicked$.next();
  }
}
